import { ROAM_SCENE } from '@/config/contant'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      sceneObj: null,
    }
  },
  mounted() {
    this.emitRoamScene()
  },
  computed: {
    ...mapGetters(['getVideoInfo']),
  },
  methods: {
    emitRoamScene() {
      this.$vgo.on(ROAM_SCENE, obj => {
        this.sceneObj = obj
        this.beforeSwitchScene()
      })
    },
    beforeSwitchScene() {
      const { sceneId } = JSON.parse(this.sceneObj.datastr)
      this.getVideoSceneList.find((item, idx) => {
        if (item.scene_id === sceneId) {
          this.switchScene(idx, sceneId, item.file_url)
        }
      })
    },
  },
}
